// AWSステージング環境設定
// eslint-disable-next-line import/no-anonymous-default-export
// export default {
//   API: {
//     endpoints : [
//       {
//         name: "connectivity_check_v1",
//         endpoint: "https://mon61fr2w6.execute-api.ap-northeast-1.amazonaws.com/v1"
//       },
//       {
//         name: "connectivity_check_dev",
//         endpoint: "https://mon61fr2w6.execute-api.ap-northeast-1.amazonaws.com/dev"
//       }
//     ]
//   }
// }

// AWS本番環境設定
// eslint-disable-next-line import/no-anonymous-default-export
export default {
  API: {
    endpoints : [
      {
        name: "connectivity_check_v1",
        endpoint: "https://ivs5d7g6n8.execute-api.ap-northeast-1.amazonaws.com/v1"
      }
    ]
  }
}
